import React from 'react'
import { Button } from 'react-bootstrap'
import SendNotification from '../../features/notifications/list/SendNotification'

const NotificationSent = () => {
  const [open, setOpen] = React.useState<boolean>(false)
  return (
    <div>
      <div className={'d-flex flex-row justify-content-between'}>
        <div>Title</div>
        <div>
          <Button
            onClick={() => {
              setOpen(true)
            }}
          >
            Envoyer
          </Button>
        </div>
      </div>
      <SendNotification
        show={open}
        onHide={() => {
          setOpen(false)
        }}
      />
    </div>
  )
}

export default NotificationSent
